<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap" :class="{emptyList : !firstDataSet}">
          <div class="searchListWrap pb-30" v-if="firstDataSet">
            <h5 class="period" v-if="dataFlag">{{dateStart}}<b>-</b>{{dateEnd}}</h5>
            <h5 class="period" v-else>날짜 선택하기</h5>
            <div class="inBtn pre">
                <button type="button" class="search function" @click="callDateSearch()">조회</button>
            </div>
          </div>
          <div class="searchListWrap bone">
          <div class="surgeryItemWrap" v-if="firstDataSet">
            <div class="surgeryItem" @click="selectedItem(s)" v-for="(surgeryInfo, s) in this.dataArray" :key="s">
              <p>진료의: <b class="doctor">{{surgeryInfo.doctorName}} 원장님</b></p>
              <p>수술일정: <b class="date">{{surgeryInfo.surgeryDate | moment('YYYY-MM-DD')}} 원장님</b></p>
              <p>수술명: <b class="sugery">{{surgeryInfo.surgeryName}}</b></p>
            </div>
          </div>
          <div v-else>
            <div class="center_text surgery">
              <div class="searchListWrap replace" >
                <h5 class="period">날짜 선택하기</h5>
                <div class="inBtn pre">
                  <button type="button" class="search function" @click="callDateSearch()">조회</button>
                </div>
              </div>
              <div class="imgWrap">
                <img src="@/assets/images/error.svg">
              </div>
              <div class="ct_content">
                <p>귀하의 완료된 수술 일정 기록이 없습니다</p>
                <p>병원으로 문의해 주시기 바랍니다.</p>
              </div>
              <div class="small_btnWrap one" v-if="firstDataSet">
                <button type="button" @click.prevent="">수술일정 입력 요청</button>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '수술일정조회',
        prevUrl: '/'
      },
      dataFlag: false,
      dateStart: '',
      dateEnd: '',
      IsWhole: '',
      monthDate: '',
      yesterDay: '',
      today: '',
      beginDay: '',
      dateMutated: '',
      firstDataSet: false,
      dataArray: []
    }
  },
  computed: {
    ...mapGetters([
      'getSurgeryList',
      'getSurgeryDate'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_SURGERY_DONE',
      'SET_SURGERY_CODE'
    ]),
    ...mapActions([
      'SURGERY_LIST'
    ]),
    callDateSearch () {
      this.$store.commit('SET_SURGERY_DONE', true)
      this.$router.push('/surgery/surgeryReservationDate')
    },
    // 오늘 ~ 오늘 + 한달 날짜 조회
    getDefaultDate () {
      let date = new Date()
      // let monthDate = date.getTime() - (7 * 24 * 60 * 60 * 1000)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      let dateMutated = new Date(year, month, 0)
      this.beginDay = this.$moment(new Date(year, 0, 1)).format('YYYY-MM-DD')
      date = this.$moment(date).format('YYYY-MM-DD')
      // monthDate = this.$moment(monthDate).format('YYYY-MM-DD')
      dateMutated = this.$moment(dateMutated).format('YYYY-MM-DD')

      // this.monthDate = monthDate
      this.today = date
      this.dateMutated = dateMutated
      this.getYesterDay()
    },
    getYesterDay () {
      const nowDate = new Date()
      const yesterDate = nowDate.getTime() - (1 * 24 * 60 * 60 * 1000)
      nowDate.setTime(yesterDate)
      const yesterYear = nowDate.getFullYear()
      const yesterMonth = nowDate.getMonth() + 1
      const yesterDay = nowDate.getDate()
      let mutatedYesterMonth
      let mutatedYesterDay
      if (yesterMonth < 10) {
        mutatedYesterMonth = '0' + yesterMonth
      } else {
        mutatedYesterMonth = yesterMonth
      }
      if (yesterDay < 10) {
        mutatedYesterDay = '0' + yesterDay
      } else {
        mutatedYesterDay = yesterDay
      }
      const resultDate = yesterYear + '-' + mutatedYesterMonth + '-' + mutatedYesterDay
      this.yesterDay = resultDate
    },
    async fetchData () {
      try {
        let requestData
        if (this.dataFlag === false) {
          requestData = {
            // 이번년도1일부터 오늘 이전 1일까지
            gte: this.beginDay,
            lte: this.yesterDay,
            default: false
          }
        } else {
          requestData = {
            gte: this.dateStart,
            lte: this.dateEnd,
            default: this.IsWhole
          }
        }
        console.log('dataFlag: ', this.dataFlag)
        console.log('requestData: ', requestData)
        await this.SURGERY_LIST(requestData)
          .then(() => this.carryData())
      } catch (error) {
        console.log('error :', error);
        console.log('수술일정 리스트 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    carryData () {
      const arrayWrap = []
      console.log('가져온 날짜: ', this.getSurgeryDate)
      console.log('수술일정 리스트: ', this.getSurgeryList)
      if (this.getSurgeryList.length >= 1) {
        this.firstDataSet = true
        for (let i = 0; i < this.getSurgeryList.length; i++) {
          if (this.getSurgeryList[i].state === '취소') {
            arrayWrap.push(this.getSurgeryList[i])
          }
        }
        this.dataArray = arrayWrap
      } else {
        this.firstDataSet = false
      }
    },
    selectedItem (order) {
      const copyArray = JSON.parse(JSON.stringify(this.dataArray))
      const surgeryCode = copyArray[order].surgeryCode
      console.log('가져온 수술코드', surgeryCode)
      const surgeryDate = copyArray[order].surgeryDate
      console.log('가져온 수술일시', surgeryDate)
      const surgeryInfo = {
        surgeryCode: surgeryCode,
        surgeryDate: surgeryDate
      }
      this.$store.commit('SET_SURGERY_CODE', surgeryInfo)
      this.$router.push('/scar/scarAdd')
    }
  },
  created () {
    console.log('this.getSurgeryDate.length: ', this.getSurgeryDate.length)
    if (this.getSurgeryDate.length >= 1) {
      this.dataFlag = true
      this.dateStart = this.getSurgeryDate[0]
      this.dateEnd = this.getSurgeryDate[1]
      this.IsWhole = this.getSurgeryDate[2]
    } else {
      this.dataFlag = false
    }
    this.getDefaultDate()
    this.fetchData()
  },
  beforeDestroy () {
    this.SET_POPUP(false)
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  }
}
</script>

<style lang="scss" scoped>
  .searchListWrap {
    &.replace {
      h5.period {
      }
    }
    &.bone {
      padding:20px 0;
    }
    .surgeryItemWrap {
      margin: 0 0 20px 0;
      .surgeryItem {
        padding: 12.5px 20px;
        border-radius: 5px;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
        background-color: #707070;
        max-width: 230px;
        margin: 0 auto 20PX auto;
        border: 2px solid #707070;
        cursor:pointer;
        &:hover {
          background:#ff6565;
          border:2px solid #ff6565
        }
        &:last-of-type {
          margin:0 auto;
        }
        p {
          font-family: NotoSansCJKkr;
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: center;
          color: #fff;
          b {
            font-size:12px;
          }
        }
      }
    }
  }

</style>
